module.exports = __webpack_public_path__ + "media/images/lb/446-91ef3f03baad19f5137f36a66e7695c1.svg";